import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

// const DetalleNivel2 = props => {
//   return (
//     <option>{props.elemento.descrDocumento}</option>
//   )
// };

// const ListaDoc = ({handleLista, list}) => {
//   const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
//   return(
//     <div>
//       <select className="ui simple selection dropdown fluid" name="descrDocumento" id="miLista1" onChange={handleLista}>
//         <option value="">Seleccionar...</option> 
//         {Nivel2Detalle}
//       </select>
//     </div>
//   )
// };

const ListaDoc = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrDocumento" id="miLista" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Nit</option>
        <option>CC</option>
        <option>CE</option>
        <option>Pasaporte</option>
      </select>
    </div>
  )
};

const AddProveed2 = ({styles, list1, handleLista, handleSubmit, handleChange, 
                      args, errors}) => {
// console.log(args)
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Proveedor nuevo
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" width="50%">
                <Form.Field>
                  <label style={styles.label}>Tipo de documento de identidad</label>
                  <ListaDoc styles={styles} handleLista={handleLista} />
                </Form.Field>
              </div>
              <div className="column" width="50%">
                <Form.Field>
                  <label style={styles.label}>Número de documento de identidad</label>
                  <Form.Input autoComplete="off" name="numeroDocumento" id="numeroDocumento" onChange={handleChange} placeholder='Número de documento' icon={!errors.length?null: _find(errors, {path:'numeroDocumento'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
            </div>
          </div>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" width="50%">
                <Form.Field>
                  <label style={styles.label}>Proveedor</label>
                  <Form.Input autoComplete="off" name="descrProveed" id="descrProveed" onChange={handleChange} placeholder='Proveedor' icon={!errors.length?null: _find(errors, {path:'descrProveed'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
              <div className="column" width="50%">
                  <Form.Field>
                    <label style={styles.label}>Contacto</label>
                    <Form.Input autoComplete="off" name="contacto" id="contacto" onChange={handleChange} placeholder='Contacto' icon={!errors.length?null: _find(errors, {path:'contacto'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
              </div>
            </div>
          </div>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" width="50%">
                <Form.Field>
                  <label style={styles.label}>Ciudad</label>
                  <Form.Input autoComplete="off" name="ciudad" id="ciudad" onChange={handleChange} placeholder='Ciudad' icon={!errors.length?null: _find(errors, {path:'ciudad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Ditrección</label>
                  <Form.Input autoComplete="off" name="direccion" id="direccion" onChange={handleChange} placeholder='Dirección' icon={!errors.length?null: _find(errors, {path:'direccion'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
              <div className="column" width="50%">
                <Form.Field>
                  <label style={styles.label}>Teléfono</label>
                  <Form.Input autoComplete="off" name="telefono" id="telefono" onChange={handleChange} placeholder='Teléfono' icon={!errors.length?null: _find(errors, {path:'telefono'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Correo electrónico</label>
                  <Form.Input autoComplete="off" name="email" id="email" onChange={handleChange} placeholder='Correo electrónico' icon={!errors.length?null: _find(errors, {path:'email'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
            </div>
          </div>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Button style={styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AddProveed2
